import { deepFlatChildren } from '../../core/functions/deep-flat-children.js';
import { RG_TYPE } from '../../types/rg-type.js';

/**
 * Calculates the finish floor level offset from the bottom of an `Apartment`,
 * looking for the `Module` that contains a `Door`that is flagged as `isEntrance`
 * @param obj
 * @returns
 */
function getFloorOffsetFromApartment(obj) {
    let offset = 0;
    for (const module of obj.children.filter(c => c.type === RG_TYPE.Module)) {
        if (!deepFlatChildren(module).some(c => c.type === RG_TYPE.Door && c.data && c.data.isEntrance))
            continue;
        const floors = module.children.filter(c => c.type === RG_TYPE.Floor);
        offset = Math.max(...floors.map(f => f.pos[1] + (1 - module.anchor[1]) * module.size[1]));
        break;
    }
    return offset;
}

export { getFloorOffsetFromApartment };
//# sourceMappingURL=get-floor-offset-from-object.js.map
